// extracted by mini-css-extract-plugin
export var services = "services-module--services--2jNZn";
export var servicesDesc = "services-module--services-desc--3x817";